import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

export interface Tarea {
  id: number | string;
  titulo: string;
}

export interface Lista {
  id?: number;
  titulo: string;
  tablero_id: number;
  estado?: string;
  orden?: number;
  tareas: Tarea[];
}

@Injectable({
  providedIn: 'root'
})
export class ListaService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  crearLista(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}lista/crear/`, data);
  }

  listarListasPorTablero(tablero_id: number): Observable<Lista[]> {
    return this.http.post<Lista[]>(`${this.baseUrl}lista/listar/`, { tablero_id });
  }

  listarListasTareasPorTablero(tablero_id: number): Observable<Lista[]> {
    return this.http.post<Lista[]>(`${this.baseUrl}lista/listas-tareas/`, { tablero_id });
  }


  editarLista(data: Lista): Observable<any> {
    return this.http.put(`${this.baseUrl}lista/editar/`, data);
  }

  eliminarLista(id: number): Observable<any> {
    return this.http.post(`${this.baseUrl}lista/eliminar/`, { id });
  }
}
